import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import localeRU from "../locales/ru/ru.json"
import localeRUClient from "../locales/ru/client.json"
// Msg 270: tizim 2 tilda — o'zbekcha lokal (yetishmagan kalitlar ru'ga tushadi)
import localeUZ from "../locales/uz/uz.json"
// Egasi (2026-08-31): 3-til — inglizcha; yetishmagan kalitlar ru'ga tushadi
import localeEN from "../locales/en/en.json"

const resources = {
  ru: {
    translation: localeRU,
    client: { ...localeRU, ...localeRUClient },
  },
  uz: {
    translation: localeUZ,
    client: { ...localeUZ, ...localeRUClient },
  },
  en: {
    translation: localeEN,
    client: { ...localeEN, ...localeRUClient },
  },
}

// Tanlangan til localStorage'da saqlanadi (almashtirilganda sahifa reload bo'ladi,
// chunki ko'p jadval ustunlari i18n.t bilan modul yuklanishida hisoblanadi)
let savedLang = "ru"
try {
  const v = localStorage.getItem("app_lang")
  if (v === "uz" || v === "ru" || v === "en") savedLang = v
} catch {}

// Lug'atda topilmagan kalit XOM holda ("addOrder") ekranga chiqmasligi kerak.
// Zaxira tartibi:
//   1) `addFoo` → "Добавить" + `foo` kalitining tarjimasi (masalan «Добавить заказ»)
//   2) `fooBar` → so'zlarga ajratilgan o'qiladigan matn («Foo bar»)
// Bu faqat HIMOYA QATLAMI — kalitning o'zi lug'atga qo'shilishi shart.
let inFallback = false
const humanize = (key: string) =>
  key
    .replace(/[_.:-]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^./, (c) => c.toUpperCase())

const missingKeyFallback = (_lngs: readonly string[], _ns: string, key: string) => {
  if (inFallback) return humanize(key)
  inFallback = true
  try {
    const m = /^add([A-Z].*)$/.exec(key)
    if (m) {
      const base = m[1].charAt(0).toLowerCase() + m[1].slice(1)
      const baseText = i18n.t(base, { defaultValue: "" }) as string
      if (baseText && baseText !== base) {
        const add = (i18n.t("add", { defaultValue: "" }) as string) || ""
        return add ? `${add} ${baseText.toLowerCase()}` : baseText
      }
    }
    return humanize(key)
  } catch {
    return humanize(key)
  } finally {
    inFallback = false
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    supportedLngs: ["ru", "uz", "en"],
    fallbackLng: ["ru"],
    saveMissing: true,
    parseMissingKeyHandler: (key: string) => missingKeyFallback([], "translation", key),
  })

i18n.on("missingKey", function (lngs, namespace, key, res) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.warn(`[i18n] tarjimasiz kalit: "${key}" (${lngs?.join?.(",")})`)
  }
})

export default i18n
